module.exports = __webpack_public_path__ + "a17d279f/img/product-icon-grey.b248963c.svg";